<template>
  <div class="property">
    <header>
      <a href="#back" @click.prevent="$router.go(-1)">
        <img :src="require('@/assets/images/chevron_left.svg')" class="icon icon-shadow" />
      </a>
    </header>
    <section class="map">
      <gmap-map
        :center="center"
        :markers="markers"
        :zoom="18"
        style="width:100%;  height: 100%;"
        :options="{
         zoomControl: true,
         mapTypeControl: false,
         scaleControl: false,
         streetViewControl: false,
         rotateControl: false,
         fullscreenControl: true,
         disableDefaultUi: false
       }">
        <gmap-marker
          :key="index"
          v-for="(m, index) in markers"
          :position="m.position"
          :clickable="false"
          :draggable="false"
          @click="center=m.position"
        />
      </gmap-map>
    </section>
  </div>
</template>

<script>
export default {
  name: 'PropertyMap',
  data() {
    return {
      center: { lat: 20.430, lng: -49.970 },
      markers: [],
      places: [],
      currentPlace: null,
    };
  },
  mounted() {
    this.addMarker();
  },
  beforeCreate() {
    this.$store.commit('headerModeAuth');
    this.$store.commit('headerBack', true);
    this.$store.commit('headerSearch', false);
  },
  methods: {
    async addMarker() {
      this.currentPlace = await this.getLatLng();
      if (!this.currentPlace) return;

      this.markers.push({ position: this.currentPlace });
      this.places.push(this.currentPlace);
      this.center = this.currentPlace;
      this.currentPlace = null;
    },
    async getLatLng() {
      const { propertyId } = this.$route.params;
      const { properties } = this.$store.state;
      const propertySel = properties.find((property) => property.id === parseInt(propertyId, 10));
      if (!propertySel) {
        this.$store.commit('addMessageError', 'Não foi possivel encontrar o endereço.');
        return null;
      }
      return {
        lat: parseFloat(propertySel.map.lat),
        lng: parseFloat(propertySel.map.lng),
      };
    },
  },
};
</script>

<style scoped>
  .property{
    width: 100%;
    height: auto;
    min-height: 100vh;
    display: flex;
    overflow: hidden;
    position: absolute;
    left: 0;
    top: 0;
    background-color: var(--color-dashboard);
    z-index: 8001;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
  }
  .property header{
    width: calc(100% + 60px);
    height: 60px;
    overflow: hidden;
    position: relative;
    top: 0;
    left: 0;
    z-index: 8002;
  }
  .property header .icon{
    position: fixed;
    top: 10px;
    left: 10px;
    animation: menu-in .3s linear forwards;
    animation-delay: .8s;
    opacity: 0;
  }
  .property > .map{
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    background-image: linear-gradient(
      135deg,
      var(--color-secondary),
      var(--color-secondary-dark)
    );
  }
</style>
